module.exports = __webpack_public_path__ + "assets/images/pages/stack/back.png?5b58227e";